/**
 * Fonte única da regra de resolução de realm (abi vs third).
 *
 * Esta regra estava duplicada/encapsulada dentro de `initializeTenantSelection`
 * (tenant-selection.ts) e também era inferida indiretamente em `get-idp.ts`.
 * Centralizar aqui evita divergência entre os pontos que decidem o realm.
 */

export const REALM_ABI = 'abi';
export const REALM_THIRD = 'third';

/** Sufixo que identifica um tenant third-party (revenda / 3pd). */
export const THIRD_PARTY_TENANT_SUFFIX = '-3pd';

/** Padrões de hostname que indicam realm `third` quando nenhum é configurado. */
export const DEFAULT_REVENDA_HOST_PATTERNS = ['revenda'];

/**
 * Indica se o tenant é third-party (sufixo `-3pd`). Usado apenas como heurística
 * de escolha de tenant default — NÃO determina mais o realm (ver `getRealm`).
 */
export function isThirdPartyTenant(tenant?: string | null): boolean {
  return !!tenant && tenant.endsWith(THIRD_PARTY_TENANT_SUFFIX);
}

/**
 * Determina o realm exclusivamente a partir do hostname: se o host contém algum
 * dos `revendaHostPatterns` configurados (default `['revenda']`) => `third`;
 * caso contrário => `abi`. O sufixo `-3pd` do tenant NÃO força mais `third` —
 * a decisão é baseada no domínio, permitindo que tenants `-3pd` acessados em um
 * host Ambev autentiquem no realm Ambev.
 */
export function getRealm(
  hostname: string,
  revendaHostPatterns: string[] = DEFAULT_REVENDA_HOST_PATTERNS,
): string {
  const patterns = revendaHostPatterns.length
    ? revendaHostPatterns
    : DEFAULT_REVENDA_HOST_PATTERNS;

  return patterns.some((pattern) => hostname.includes(pattern))
    ? REALM_THIRD
    : REALM_ABI;
}
